import { WalletEnable } from './../contract/wallet'
import { markRaw } from 'vue'
import { Module } from 'vuex'

import detectEthereumProvider from '@metamask/detect-provider'
import type { MetaMaskInpageProvider } from '@metamask/providers'
import { ExternalProvider, Web3Provider } from '@ethersproject/providers'
import { providers, utils } from 'ethers'
import * as rpc from '@/contract/rpc'
import redpackContract from '@/contract/redPacketAddress'

export interface State {
  ready: boolean
  wallet: WalletEnable | null
  chainId: rpc.Chain | null
  balance: string
  account: {
    show: string
    normal: string
  }
}

export const store = {
  namespaced: true,
  state: () => ({
    ready: false,
    wallet: null,
    chainId: null,
    balance: '0',
    account: {
      show: '',
      normal: ''
    }
  }),
  getters: {
    rpc: state => rpc.address[state.chainId ?? rpc.Chain.polygon],
    contract: state => redpackContract[state.chainId ?? rpc.Chain.polygon],
    info: state => rpc.info[state.chainId ?? rpc.Chain.polygon]
  },
  mutations: {
    INIT_WALLET (state, wallet: WalletEnable) {
      state.wallet = markRaw(wallet)
    },

    SET_READY (state, payload: boolean) {
      state.ready = payload
    },

    SET_CHAINID (state, chainId: number) {
      state.chainId = chainId
    },

    SET_ACCOUNT (state, address: string) {
      state.account.normal = address.toLowerCase()
      state.account.show = address
    },

    SET_BALANCE (state, balance: string) {
      state.balance = balance
    }
  },
  actions: {
    async init ({ commit, dispatch }) {
      const walletEnable = new WalletEnable()

      await walletEnable.init()

      commit('INIT_WALLET', walletEnable)

      const account = await walletEnable.wallet.enable()

      const utilAccount = await utils.getAddress(account[0])

      commit('SET_ACCOUNT', utilAccount)

      const chainId = walletEnable.wallet.chainId

      commit('SET_CHAINID', Number(chainId))

      commit('SET_READY', true)

      dispatch('pollBalance')

      return walletEnable
    },

    async getBalance ({ state }) {
      if (!state.wallet) return

      const data = await state.wallet.provider.getBalance(state.account.normal)

      return data
    },

    async pollBalance ({ dispatch, commit }) {
      try {
        const data = await dispatch('getBalance')

        commit('SET_BALANCE', data.toString())

        console.log('pollBalance', data)
      } catch (error) {
        console.error('getBalance', error)
      } finally {
        setTimeout(() => {
          dispatch('pollBalance')
        }, 5000)
      }
    }
  }
} as Module<State, any>
